import { ChangeDetectionStrategy, Component } from '@angular/core';
import { IconTypes } from '@shared/v2/models';
import { SdModalService, SdvorInputComponent } from '../../v2';
import { SdBottomSheetService } from '../../v2/components/bottom-sheet/bottom-sheet-service';
import { SdvorButtonComponent } from '../../v2/components/button';
import { SdvorIconComponent } from '../../v2/components/icon';

@Component({
  selector: 'sd-test-modal',
  template: '<div>Hello from test modal </div> <div> <input type="text "> </div>',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SdTestModalComponent {}

/**
 * Контейнер для тестирования компонентов дизайн системы.
 *
 * Чтобы отобразить тестируемый компонент в песочнице, нужно:
 * 1. Импортировать модуль тестируемого компонента в SandboxComponent;
 * 2. Добавить селектор компонента в шаблон компонента SandboxComponent;
 * 3. Перейти по ссылке в браузере https://localhost:4200/sandbox
 */
@Component({
  selector: 'sd-sandbox',
  templateUrl: './sandbox.component.html',
  styleUrls: ['./sandbox.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SdvorButtonComponent, SdvorIconComponent, SdvorInputComponent],
})
export class SandboxComponent {
  iconSizes = ['xs', 's', 'm', 'l', 'xl'];
  iconTypes = Object.values(IconTypes);

  constructor(
    private modalService: SdModalService,
    private bottomSheetService: SdBottomSheetService,
  ) {}

  onOpenModal(): void {
    this.modalService.open(SdTestModalComponent, { maxWidth: '400px', title: 'Заявка', modalType: 'compact' });
  }

  onOpenBottomSheet(): void {
    this.bottomSheetService.open(SdTestModalComponent, {
      breakpoints: [20, 50, 90],
      init: {
        type: 'percent',
        value: 50,
      },
      title: 'Шит с блокированным оверлеем',
      ignoreOutsideClick: true,
      blockOverlay: true,
      hasCloseButton: true,
    });
  }

  onOpenBottomSheet2(): void {
    this.bottomSheetService.open(SdTestModalComponent, {
      breakpoints: [30, 70],
      init: {
        type: 'percent',
        value: 30,
      },
      title: 'Шит не с блокированным оверлеем',
      hasCloseButton: true,
      ignoreOutsideClick: true,
      blockOverlay: false,
    });
  }

  onOpenBottomSheet3(): void {
    this.bottomSheetService.open(SdTestModalComponent, {
      breakpoints: [20, 50, 90],
      init: {
        type: 'percent',
        value: 50,
      },
      title: 'Шит3 ',
      ignoreOutsideClick: true,
      blockOverlay: true,
      hasCloseButton: true,
    });
  }
}
